import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
import confirmD7e05f from './confirm'
/**
* @see \App\Http\Controllers\TwoFactorRecoveryController::send
 * @see app/Http/Controllers/TwoFactorRecoveryController.php:43
 * @route '/login/help/two-factor'
 */
export const send = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: send.url(options),
    method: 'post',
})

send.definition = {
    methods: ["post"],
    url: '/login/help/two-factor',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\TwoFactorRecoveryController::send
 * @see app/Http/Controllers/TwoFactorRecoveryController.php:43
 * @route '/login/help/two-factor'
 */
send.url = (options?: RouteQueryOptions) => {
    return send.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\TwoFactorRecoveryController::send
 * @see app/Http/Controllers/TwoFactorRecoveryController.php:43
 * @route '/login/help/two-factor'
 */
send.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: send.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\TwoFactorRecoveryController::send
 * @see app/Http/Controllers/TwoFactorRecoveryController.php:43
 * @route '/login/help/two-factor'
 */
    const sendForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: send.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\TwoFactorRecoveryController::send
 * @see app/Http/Controllers/TwoFactorRecoveryController.php:43
 * @route '/login/help/two-factor'
 */
        sendForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: send.url(options),
            method: 'post',
        })
    
    send.form = sendForm
/**
* @see \App\Http\Controllers\TwoFactorRecoveryController::confirm
 * @see app/Http/Controllers/TwoFactorRecoveryController.php:29
 * @route '/login/help/two-factor/confirm/{token}'
 */
export const confirm = (args: { token: string | number } | [token: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: confirm.url(args, options),
    method: 'get',
})

confirm.definition = {
    methods: ["get","head"],
    url: '/login/help/two-factor/confirm/{token}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\TwoFactorRecoveryController::confirm
 * @see app/Http/Controllers/TwoFactorRecoveryController.php:29
 * @route '/login/help/two-factor/confirm/{token}'
 */
confirm.url = (args: { token: string | number } | [token: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { token: args }
    }

    
    if (Array.isArray(args)) {
        args = {
                    token: args[0],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        token: args.token,
                }

    return confirm.definition.url
            .replace('{token}', parsedArgs.token.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\TwoFactorRecoveryController::confirm
 * @see app/Http/Controllers/TwoFactorRecoveryController.php:29
 * @route '/login/help/two-factor/confirm/{token}'
 */
confirm.get = (args: { token: string | number } | [token: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: confirm.url(args, options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\TwoFactorRecoveryController::confirm
 * @see app/Http/Controllers/TwoFactorRecoveryController.php:29
 * @route '/login/help/two-factor/confirm/{token}'
 */
confirm.head = (args: { token: string | number } | [token: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: confirm.url(args, options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\TwoFactorRecoveryController::confirm
 * @see app/Http/Controllers/TwoFactorRecoveryController.php:29
 * @route '/login/help/two-factor/confirm/{token}'
 */
    const confirmForm = (args: { token: string | number } | [token: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: confirm.url(args, options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\TwoFactorRecoveryController::confirm
 * @see app/Http/Controllers/TwoFactorRecoveryController.php:29
 * @route '/login/help/two-factor/confirm/{token}'
 */
        confirmForm.get = (args: { token: string | number } | [token: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: confirm.url(args, options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\TwoFactorRecoveryController::confirm
 * @see app/Http/Controllers/TwoFactorRecoveryController.php:29
 * @route '/login/help/two-factor/confirm/{token}'
 */
        confirmForm.head = (args: { token: string | number } | [token: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: confirm.url(args, {
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    confirm.form = confirmForm
const twoFactor = {
    send: Object.assign(send, send),
confirm: Object.assign(confirm, confirmD7e05f),
}

export default twoFactor